import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class SiteLayout extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/site/layout'
    super(store, path)
  }
}
